module.exports = __webpack_public_path__ + "static/media/banner-empresa.e5d53c6b.jpg";